// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"89d48eb7","455":"b9cd2477","977":"70bcb045"}[chunkId] + ".chunk.js";
};